export enum PortalContextKind {
    Employee = 'EmployeePortal',
    Workspace = 'Workspace',
    Producer = 'ProducerPortal',
}

export interface WorkspacePortalContext {
    Id: string;
    Name: string;
    IsSubscriptionActive: boolean;
    SubscriptionNotRequired: boolean;
    NeedToValidateSubscription: boolean;
}

export interface ProducerPortalContext {
    Id: string;
    Name: string;
    AccessState: 'Active' | 'Suspended' | 'Terminated';
    Role: string;
}

export interface EmployeePortalEmployerContext {
    EmploymentId: string;
    OrganizationName: string;
    PositionTitle: string;
    IsActive: boolean;
    StartedDate?: string | null;
    EndedDate?: string | null;
    LastReviewDate?: string | null;
    ReviewCount: number;
}

export interface PortalAccessDiscovery {
    Workspaces: WorkspacePortalContext[];
    Employers: EmployeePortalEmployerContext[];
    Producers: ProducerPortalContext[];
    DefaultEmploymentId?: string | null;
}

export const hasEmployeePortalAccess = (discovery: PortalAccessDiscovery): boolean =>
    (discovery.Employers?.length ?? 0) > 0;

export const hasProducerPortalAccess = (discovery: PortalAccessDiscovery): boolean =>
    (discovery.Producers?.filter(producer => producer.AccessState === 'Active')?.length ?? 0) > 0;

export type PortalContextSelection =
    | { Kind: PortalContextKind.Employee }
    | { Kind: PortalContextKind.Workspace; OrganizationId: string }
    | { Kind: PortalContextKind.Producer; ProducerCompanyId: string };

export const employeePortalStorageKey = PortalContextKind.Employee;

export const workspacePortalStorageKey = (organizationId: string) =>
    `${PortalContextKind.Workspace}:${organizationId}`;

export const producerPortalStorageKey = (producerCompanyId: string) =>
    `${PortalContextKind.Producer}:${producerCompanyId}`;

export const serializePortalContext = (context: PortalContextSelection): string =>
    context.Kind === PortalContextKind.Employee
        ? employeePortalStorageKey
        : context.Kind === PortalContextKind.Workspace
            ? workspacePortalStorageKey(context.OrganizationId)
            : producerPortalStorageKey(context.ProducerCompanyId);
